import { AppContext } from 'appContext';
import { Header } from 'components/Header/Header';
import { IS_DEMO } from 'config/constants';
import { useContext, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import './style.scss';
import { ErrorBoundary } from 'react-error-boundary';
import { ApiErrorFallback } from 'components/APIErrorFallback/ApiErrorFallback';
import { QueryErrorResetBoundary } from '@tanstack/react-query';

export const Layout = () => {
  const { state } = useContext(AppContext);
  const location = useLocation();
  return useMemo(() => {
    return (
      <div className="wrapper" data-testid="pageWrapper">
        {((state.auth.token || IS_DEMO) && (
          <main className="page-content">
            <Header />
            <div className={`layout `}>
              <QueryErrorResetBoundary>
                {({ reset }) => (
                  <ErrorBoundary
                    onReset={reset}
                    FallbackComponent={ApiErrorFallback}
                    key={location.pathname}
                  >
                    <Outlet />
                  </ErrorBoundary>
                )}
              </QueryErrorResetBoundary>
            </div>
          </main>
        )) || (
          <main className="page-content">
            <div className={`layout `}>
              <Outlet />
            </div>
          </main>
        )}
      </div>
    );
  }, [!!state.auth.token, location.pathname]);
};
